export default __webpack_public_path__ + "static/img1-4f1305e0b7a116e5466cc3a8f2c44d56.jpg";